import { getApiConfig } from '../config.js';
import { getMessagingBaseUrl } from '../services.js';
import { createXmHeaders } from './headers.js';
import {
  ensureValidToken,
  clearAccessToken,
} from './tokenService.js';

interface FetchOptions extends RequestInit {
  skipAuth?: boolean;
  _retryCount?: number;
}

export async function apiFetch(
  path: string,
  options: FetchOptions = {},
): Promise<Response> {
  const config = getApiConfig();
  const url = path.startsWith('http') ? path : `${config.serverUrl}${path}`;

  const headers = createXmHeaders();
  // Merge in any caller-provided headers
  if (options.headers) {
    new Headers(options.headers).forEach((value, key) => {
      headers.set(key, value);
    });
  }
  if (!headers.has('Content-Type') && options.body) {
    headers.set('Content-Type', 'application/json');
  }

  if (!options.skipAuth) {
    const token = await ensureValidToken();
    headers.set('Authorization', `Bearer ${token}`);
  }

  const { skipAuth: _, _retryCount: __, ...fetchOptions } = options;
  const response = await fetch(url, { ...fetchOptions, headers });

  if (response.status === 401 && !options.skipAuth) {
    const retryCount = options._retryCount ?? 0;
    if (retryCount < 1) {
      clearAccessToken();
      const newToken = await ensureValidToken();
      headers.set('Authorization', `Bearer ${newToken}`);
      return apiFetch(path, { ...options, _retryCount: retryCount + 1 });
    }
  }

  return response;
}

export async function messagingFetch(
  path: string,
  options: FetchOptions = {},
): Promise<Response> {
  const baseUrl = await getMessagingBaseUrl();
  return apiFetch(`${baseUrl}${path}`, options);
}
